import merge from 'deepmerge'
import { isPlainObject } from 'is-plain-object'

import { uniq, join, mapify, ParsingError } from './parsing-utils'
import Mechanism from '../models/mechanism'
import Playbook from '../models/playbook'

export default function parsePlaybook (name, rawPlaybook, rulebook, mechanismParser) {
  const mechanisms = getMechanisms(rulebook.mechanisms, mechanismParser.parseAll(rawPlaybook.mechanisms))
  const rules = getRules(mechanisms, mechanismParser)
  const fields = getFields(rules, rawPlaybook, name)
  return new Playbook({ originalRulebook: rulebook, name, mechanisms, rules, fields })
}

function getMechanisms (rulebookMechanisms, playbookMechanisms = [], basicMechainsm) {
  return join(playbookMechanisms, rulebookMechanisms).filter(uniq('name'))
}

function getRules (mechanisms, mechanismParser) {
  const rules = merge.all(mechanisms, { isMergeableObject: item => Array.isArray(item) || isPlainObject(item) || item instanceof Mechanism })
  delete rules.name
  mechanismParser.addBasicData(rules)
  return rules
}

function getFields (rules, rawPlaybook, name) {
  const globalFields = mapify(rules.globalFields, 'name', 'value')
  return mapify(rules.playbookFields, 'name', fieldDefinition => rawPlaybook[fieldDefinition.name], validateField(name), globalFields)
}

function validateField (playbookName) {
  return (name, value, fieldDefinition) => {
    if (!fieldDefinition.optional && value === undefined) {
      throw new ParsingError(`Missing field ${name} in playbook ${playbookName}`)
    }
  }
}
